export default "__VITE_ASSET__BMv_7BXM__"